import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import ReactHtmlParser from "react-html-parser"

export default ({ props }) => {
  // console.log(props)

  const query = useStaticQuery(graphql`{
  allMediaImage {
    edges {
      node {
        drupal_id
        field_media_image {
          alt
        }
        relationships {
          field_media_image {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH)
              }
              publicURL
            }
          }
        }
      }
    }
  }
}
`)

  let parsed = new ReactHtmlParser(props.value, {
    transform: function transform(node) {
      if (node.type === "tag" && (node.name === "drupal-media" || node.name === "img")) {
        const uuid = node.attribs["data-entity-uuid"]
        const image = query.allMediaImage.edges.find((edge, _) => {
          return edge.node.drupal_id === uuid
        })
        if (uuid) {
          let imageAlign = undefined
          if (node.attribs["data-align"] === "left") {
            imageAlign = { marginRight: "auto" }
          } else if (node.attribs["data-align"] === "right") {
            imageAlign = { marginLeft: "auto" }
          } else {
            imageAlign = { margin: "auto" }
          }
          return (
            // <Row>
            //   <Col xs={node.attribs["data-col-xs"]} md={node.attribs["data-col-md"]} xl={node.attribs["data-col-xl"]}>
            <img
              key={uuid}
              src={
                image.node.relationships.field_media_image.localFile.publicURL
              }
              alt={image.node.field_media_image.alt}
              style={{ ...imageAlign, width: "100%" }}
            />
            //   </Col>
            // </Row>
          )
        } else {
          return <p className={`bg-warning text-danger`}>Media not found!</p>
        }
      }
    },
  })

  // console.log(parsed)

  return <div className={`drupal__field__body`} style={{ display: "flex", flexWrap: "wrap" }}>{parsed}</div>
}
